var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6412 6.90839L9.14557 10.4837C9.05276 10.5242 8.94728 10.5242 8.85448 10.4837L1.35889 6.90839",
    stroke: "#005DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6412 9.09155L9.14557 12.6669C9.05276 12.7074 8.94728 12.7074 8.85448 12.6669L1.35889 9.09155",
    stroke: "#005DAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6412 11.2748L9.14557 14.8501C9.05276 14.8906 8.94728 14.8906 8.85448 14.8501L1.35889 11.2748",
    stroke: "#005DAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1457 8.30053C9.05289 8.34104 8.94741 8.34104 8.85461 8.30053L1.39904 5.05851C1.26667 5.00053 1.18115 4.86972 1.18115 4.72521C1.18115 4.5807 1.26667 4.44988 1.39904 4.39191L8.85461 1.14988C8.94741 1.10938 9.05289 1.10938 9.1457 1.14988L16.6013 4.39191C16.7336 4.44988 16.8192 4.5807 16.8192 4.72521C16.8192 4.86972 16.7336 5.00053 16.6013 5.05851L9.1457 8.30053Z",
    stroke: "#005DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/Floor.1a163ccf47eb232126228d8fc7ccd98e.svg";
export { ForwardRef as ReactComponent };